import { SubCustomerMarkUp } from '../../../../types/Responses'

export function getMarkUpId(
	articleType: SubCustomerMarkUp['articleType'],
	diameter: SubCustomerMarkUp['diameter'],
): string {
	return String(articleType) + '_' + String(diameter)
}
